
import { mapState, mapMutations } from "vuex";

export default {
	name: 'ui-page-header',

	components: {
	

	},

	filters: {

	},


	data() {
		return {
			
		};
	},
	watch: {
	},
	computed: {
		...mapState(["user"]),
	},
	created() {


	},
	mounted() {
		
	},


	beforeDestroy() {
	},

	methods: {

		...mapMutations([""]),

	}
}
